import { get } from 'lodash'
import { createSelector } from 'reselect'

export const getAuth = state => get(state, 'authentication')

export const isLoggedIn = createSelector(
  getAuth,
  ({ userId }) => userId !== undefined
)
